// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** function to get dimensions
  usage example to get \`tablet\` value from \`\$page-max-widths\`
  .class {
    max-width: dim(\$page-max-widths, tablet);
  }

 */
.select-dropdown-module__item___xCDis {
  color: var(--neutral100, #2c2e30);
  font-size: 0.875rem;
  cursor: pointer;
  padding: 10px;
  z-index: 9999;
}
.select-dropdown-module__item--active___bMcOi {
  background-color: rgba(var(--base-rgb, 244, 244, 247), 0.3);
}
.select-dropdown-module__item--inactive___y9AoE {
  background-color: var(--surface1, #fff);
}

.select-dropdown-module__wrapper___kZvPs {
  margin-top: 10px;
  display: none;
  background-color: var(--surface1, #fff);
  border: 1px solid var(--base, #f4f4f7);
  border-top: 0;
  max-height: 310px;
  overflow: auto;
  -ms-overflow-style: none;
  position: absolute;
  z-index: 10;
  box-shadow: 0 2px 12px 0 rgba(var(--neutral100-rgb, 44, 46, 48), 0.1);
  width: 100%;
}
.select-dropdown-module__wrapper--visible___eSILK {
  display: block;
}

.select-dropdown-module__title___e8xUN {
  color: var(--neutral100, #2c2e30);
  font-size: 0.875rem;
}`, "",{"version":3,"sources":["data:;charset=utf-8,/**%20function%20to%20get%20dimensions%0A%20%20usage%20example%20to%20get%20%60tablet%60%20value%20from%20%60$page-max-widths%60%0A%20%20.class%20%7B%0A%20%20%20%20max-width:%20dim($page-max-widths,%20tablet);%0A%20%20%7D%0A%0A%20*/%0A%0A@use%20'sass:map';%0A%0A@function%20dim($prop,%20$key)%20%7B%0A%20%20@return%20map.get($prop,%20$key);%0A%7D%0A","webpack://./client/app/react-components/inputs-comp/select-comp/select-dropdown.module.scss"],"names":[],"mappings":"AAAA;;;;;;EAAA;ACEA;EACE,iCAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,aAAA;AAMF;AALE;EACE,2DAAA;AAOJ;AALE;EACE,uCAAA;AAOJ;;AAHA;EACE,gBAAA;EACA,aAAA;EACA,uCAAA;EACA,sCAAA;EACA,aAAA;EACA,iBAAA;EACA,cAAA;EACA,wBAAA;EACA,kBAAA;EACA,WAAA;EACA,qEAAA;EACA,WAAA;AAMF;AAJE;EACE,cAAA;AAMJ;;AAFA;EACE,iCAAA;EACA,mBAAA;AAKF","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item": `select-dropdown-module__item___xCDis`,
	"item--active": `select-dropdown-module__item--active___bMcOi`,
	"item--inactive": `select-dropdown-module__item--inactive___y9AoE`,
	"wrapper": `select-dropdown-module__wrapper___kZvPs`,
	"wrapper--visible": `select-dropdown-module__wrapper--visible___eSILK`,
	"title": `select-dropdown-module__title___e8xUN`
};
export default ___CSS_LOADER_EXPORT___;
